import { Box } from '@mui/material'
import { useState } from 'react'
import { useGetOne, useRecordContext } from 'react-admin'

import { ConfirmDamageReportFormDialog, RejectDamageReportFormDialog, ResolveDamageReportFormDialog } from './actions'
import IncidentReportEvidenceCard from './IncidentReportEvidenceCard'
import IncidentReportTimelineCard from './IncidentReportTimelineCard'
import IncidentReportShowHeader from './showHeader'
import AdvancedShow from '../../components/AdvancedShow'
import { ShowReference } from '../common/show'
import { VehicleShowLayout } from '../vehicles/show'

const DamageReportShowLayout = () => {
  const record = useRecordContext()
  const { data: damageReportDetails } = useGetOne('incident-reports/details', { id: record.id })
  const [isConfirmOpen, setIsConfirmOpen] = useState(false)
  const [isRejectOpen, setIsRejectOpen] = useState(false)
  const [isResolveOpen, setIsResolveOpen] = useState(false)

  if (!damageReportDetails) return null

  const allowedActions = damageReportDetails?.allowed_actions || []

  return (
    <>
      <IncidentReportShowHeader
        allowedActions={allowedActions}
        onConfirm={() => setIsConfirmOpen(true)}
        onReject={() => setIsRejectOpen(true)}
        onResolve={() => setIsResolveOpen(true)}
      />
      <Box
        sx={{
          mx: { xs: 2, md: 3 },
          mt: 0.5,
          mb: 0.5,
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', lg: 'minmax(0, 2fr) minmax(0, 3fr)' },
          gap: 2,
        }}
      >
        <IncidentReportEvidenceCard />
        <IncidentReportTimelineCard />
      </Box>
      <ConfirmDamageReportFormDialog open={isConfirmOpen} onClose={() => setIsConfirmOpen(false)} />
      <RejectDamageReportFormDialog open={isRejectOpen} onClose={() => setIsRejectOpen(false)} />
      <ResolveDamageReportFormDialog open={isResolveOpen} onClose={() => setIsResolveOpen(false)} />
    </>
  )
}

const DamageReportAside = () => (
  <ShowReference reference="vehicles" source="vehicle_id">
    <VehicleShowLayout excluded={['organisations']} hasRedirect />
  </ShowReference>
)

export default () => (
  <AdvancedShow
    actions={false}
    component="div"
    aside={<DamageReportAside />}
    disableEventsAside
    sx={{ '& .RaShow-card': { color: 'text.primary' } }}
  >
    <DamageReportShowLayout />
  </AdvancedShow>
)
